import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=08133088&scoped=true"
import script from "./Commission.vue?vue&type=script&lang=js"
export * from "./Commission.vue?vue&type=script&lang=js"
import style0 from "./Commission.vue?vue&type=style&index=0&id=08133088&prod&scoped=true&lang=css"
import style1 from "./Commission.vue?vue&type=style&index=1&id=08133088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08133088",
  null
  
)

export default component.exports